import Vue from 'vue'
import * as VueCompositionAPI from '@vue/composition-api'
import App from './App.vue'
import store from "@/store"
import global from '@/plugins/global'
import i18n from '@/plugins/i18n'
import VueAnime from 'vue-animejs'

// Ensure composition API is available for packages using require()
if (typeof window !== 'undefined') {
  window.__VUE_INSTANCE__ = Vue;
  window.__VUE_COMPOSITION_API_INSTANCE__ = VueCompositionAPI;
  console.log('[main.js] Set window globals:', {
    hasVue: !!window.__VUE_INSTANCE__,
    hasCompositionApi: !!window.__VUE_COMPOSITION_API_INSTANCE__,
    hasRef: !!(window.__VUE_COMPOSITION_API_INSTANCE__ && window.__VUE_COMPOSITION_API_INSTANCE__.ref),
    refType: window.__VUE_COMPOSITION_API_INSTANCE__ && typeof window.__VUE_COMPOSITION_API_INSTANCE__.ref
  });
}
 
Vue.use(VueCompositionAPI)
Vue.mixin(global)
Vue.use(VueAnime)

import '@/assets/sass/main.sass'

Vue.config.productionTip = false

new Vue({
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
